import { webvonkClient } from '../../lib/supabase';

class AdminNotificationService {
  constructor() {
    this.notifications = [];
    this.listeners = [];
    this.deviceId = this.getOrCreateDeviceId();
  }

  // Generate or retrieve device ID from localStorage
  getOrCreateDeviceId() {
    let deviceId = localStorage.getItem('device_id');
    if (!deviceId) {
      // Generate unique device ID
      deviceId = 'device_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
      localStorage.setItem('device_id', deviceId);
    } else {
    }
    return deviceId;
  }

  // Get viewed notifications for this device from localStorage
  getViewedNotifications() {
    const viewed = localStorage.getItem('viewed_notifications');
    return viewed ? JSON.parse(viewed) : [];
  }

  // Mark notification as viewed on this device
  markAsViewedLocally(notificationId) {
    const viewed = this.getViewedNotifications();
    if (!viewed.includes(notificationId)) {
      viewed.push(notificationId);
      localStorage.setItem('viewed_notifications', JSON.stringify(viewed));
    }
  }

  // Fetch unread notifications for current user
  async fetchUnreadNotifications(userId) {
    try {

      // Get all active notifications
      const { data: allNotifications, error: notifError } = await webvonkClient
        .from('admin_notifications')
        .select('*')
        .eq('is_active', true)
        .or(`expires_at.is.null,expires_at.gt.${new Date().toISOString()}`)
        .order('priority', { ascending: false })
        .order('created_at', { ascending: false });

      if (notifError) {
        console.error('❌ Error fetching notifications:', notifError);
        throw notifError;
      }


      // Get viewed notifications from localStorage (per device)
      const viewedIds = new Set(this.getViewedNotifications());

      // Filter out viewed notifications
      const unreadNotifications = allNotifications?.filter(
        notif => !viewedIds.has(notif.id)
      ) || [];

      
      this.notifications = unreadNotifications;
      this.notifyListeners();

      return unreadNotifications;
    } catch (error) {
      console.error('❌ Error fetching notifications:', error);
      console.error('❌ Error details:', error.message, error.code);
      return [];
    }
  }

  // Mark notification as viewed (localStorage only - per device)
  async markAsViewed(userId, notificationId) {
    try {

      // Save to localStorage
      this.markAsViewedLocally(notificationId);

      // Remove from local notifications
      this.notifications = this.notifications.filter(n => n.id !== notificationId);
      this.notifyListeners();

      return true;
    } catch (error) {
      console.error('❌ Error marking notification as viewed:', error);
      return false;
    }
  }

  // Subscribe to notification changes
  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(cb => cb !== callback);
    };
  }

  notifyListeners() {
    this.listeners.forEach(callback => callback(this.notifications));
  }

  getUnreadCount() {
    return this.notifications.length;
  }

  getNotifications() {
    return this.notifications;
  }
}

export default new AdminNotificationService();
